<template>
  <div class="container">
    <!-- 顶部大图 -->
    <div class="inside-row">
      <img :src="topPicSrc" class="top-img" />
    </div>
    <div class="inside-row-desc">
      <img :src="poisonDescSrc" class="top-img" />
    </div>

    <!-- 系列标题区域 -->
    <div class="title-area">
      <p class="cn-title">球杆系列</p>
      <p class="en-title">CUES SERIES</p>
    </div>

    <div class="inside-row-pic">
      <img :src="xlPicSrc" class="top-img" />
    </div>

    <div class="qz-case">
      <div v-for="(item, index) in productList" :key="index">
        <!-- 标题区域 -->
        <div class="title-area">
          <p class="cn-title">{{item.name}}</p>
          <p class="en-title">{{item.alias}}</p>
        </div>

        <div class="inside-row-pic">
          <img :src="item.url+item.thumbnailSrc" class="top-img" />
        </div>

        <div class="qz-case-box" ref="caseBox">
          <div class="case-scroll-wrap" ref="scrollWrap">
            <div class="product-item" v-for="(img, i) in item.children" :key="i">
              <img @click="handleProductItemClick(item.children[0])"  :src="img.url+img.thumbnailSrc" class="product-img" />
              <p class="product-name">{{ img.name }}</p>
            </div>
          </div>
          <div v-if="item.children.length>3" class="case-control-btn prev-btn" @click="scrollCase('left', index)">
            <i class="el-icon-arrow-left"></i>
          </div>
          <div  v-if="item.children.length>3" class="case-control-btn next-btn" @click="scrollCase('right', index)">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {getProductClassifyById} from "@/api/home";

export default {
  name: 'ProductSwiper',
  data() {
    return {
      topPicSrc: require("@/assets/img/website/poison/top.jpg"),
      poisonDescSrc: require("@/assets/img/website/poison/poison_desc.jpg"),
      xlPicSrc: require("@/assets/img/website/poison/xl_bk.jpg"),
      productList:[],
    };
  },
  created() {
    this.getProductDetailById();
  },
  methods: {
    //获取产品
    async getProductDetailById() {
      try {
        const res = await getProductClassifyById('55');
        if (res.code === 200) {
          const data = res.data[0];
          this.productList = data.children ||[];
          if(this.productList){
            this.productList.forEach(item => {
              item.children = item.children.slice().reverse();
            })
          }
        } else {
          this.$message.error(res.msg || "获取产品详情失败");
        }
      } catch (error) {
        console.error("产品详情请求失败：", error);
        this.$message.error("网络异常，请稍后重试");
      }
    },

    //产品滚动
    scrollCase(direction, index) {
      // 1. 检查 this.$refs.scrollWrap 是否存在，并且是一个数组
      if (!this.$refs.scrollWrap || !Array.isArray(this.$refs.scrollWrap)) {
        return;
      }

      // 2. 使用传入的 index 从数组中获取正确的 DOM 元素
      const scrollWrap = this.$refs.scrollWrap[index];

      // 3. 检查获取到的元素是否有效
      if (!scrollWrap) return;

      const scrollStep = 360; // 每次滚动的距离
      scrollWrap.scrollBy({
        left: direction === 'left' ? -scrollStep : scrollStep,
        behavior: 'smooth' // 平滑滚动
      });
    },

    handleProductItemClick(item) {
      // 跳转子产品列表页
      this.$router.push({
        path: '/productDetail',
        query: {
          productId: item.id,
          type: 'table'
        }
      });
      // this.$router.push({
      //   path: "/fourth_cl",
      //   query: {
      //     productId: img.id,
      //     parentId: item.parentId+"-"+img.parentId,
      //     parentName: item.name
      //   }
      // });
    },

    extractSeriesName(fullName) {
      const parts = fullName.split('——');
      if (parts.length > 1) {
        return parts[1].split('系列')[0];
      }
      return '';
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  position: relative;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  //max-width: 1200px;
}

.title-area {
  text-align: center;
  margin-top: 60px;
  line-height: 1.5;
}
.cn-title {
  font-size: 30px;
  color: #333;
  font-weight: 600;
  letter-spacing: 5px;
  margin-bottom: 8px;
}
.en-title {
  font-size: 17px;
  color: #808080;
  letter-spacing: 15px;
  font-weight: bold;
}

.inside-row {
  position: relative;
  margin-top: 100px;
  width: 100%;
  overflow: hidden;
}
.inside-row-desc{
  position: relative;
  width: 100%;
  overflow: hidden;
}
.inside-row-pic{
  position: relative;
  margin-top: 60px;
  width: 100%;
  overflow: hidden;
}

.top-img {
  width: 100%;
  height: auto;
  display: block;
}
.top-img-xl{
  width: 100%;
  height: auto;
  display: block;
}

.product-item {
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background: #fff;
  width: 340px !important;
}

.product-img {
  width: 340px;
  height: 340px;
  object-fit: cover;
  background-color: #f5f5f5;

  @media (max-width: 768px) {
    height: 220px;
  }
  @media (max-width: 480px) {
    height: 180px;
  }
}

.product-name {
  margin-top: 20px;
  font-size: 18px;
  color: #333;
  font-weight: bold;
  @media (max-width: 768px) {
    font-size: 16px;
  }
}
.qz-case {
  background: #FFFFFF;
}
.qz-case-box {
  position: relative;
  max-width: 1160px;
  margin: 0 auto;
  padding: 0 50px;
}
.qz-case-box .case-scroll-wrap {
  display: flex;
  gap: 20px;
  overflow-x: auto !important;
  padding: 30px 0;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-x;
  pointer-events: auto;
  user-select: none;
  cursor: grab;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  &:active {
    cursor: grabbing;
  }
}
.qz-case-box .case-item {
  flex: 0 0 auto !important;
  width: 300px !important;
  height: 230px;
  overflow: hidden;
}
.qz-case-box .case-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  transition: transform 0.3s ease;
}
.qz-case-box .case-item:hover .case-img {
  transform: scale(1.05);
}
.qz-case-box .case-control-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  cursor: pointer;
  z-index: 10;
  color: #666;
  border: none;
  outline: none;
  transition: all 0.2s ease;
  @media (max-width: 768px) {
    display: none;
  }
  &:hover {
    background: #f6c279;
    color: #fff;
  }
}
.qz-case-box .prev-btn {
  left: 0;
}
.qz-case-box .next-btn {
  right: 0;
}
</style>